import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';

import { useSearch } from '../../hooks/useSearch';
import { CategorySlug, isCategorySlug } from '../../config';
import { useSelectedCategory } from '../../hooks/useSelectedCategory';
import { SearchSuggestionButton } from './SearchSuggestionButton';

import s from './SearchSuggestions.scss';
import { useExperiments } from '../../contexts/ExperimentsContext';
import classNames from "classnames";

export type Suggestion = {
  translationKey: string;
  slug: string;
};

const SEARCH_SUGGESTIONS_LIST: Suggestion[] = [
  {
    translationKey: 'app.topBar.search.suggestions.options.landingPage',
    slug: 'landing_page',
  },
  {
    translationKey: 'app.topBar.search.suggestions.options.portfolio',
    slug: CategorySlug.PORTFOLIO_TYPE,
  },
  {
    translationKey: 'app.topBar.search.suggestions.options.marketing',
    slug: 'marketing',
  },
  {
    translationKey: 'app.topBar.search.suggestions.options.ecommerce',
    slug: CategorySlug.ECOMMERCE,
  },
  {
    translationKey: 'app.topBar.search.suggestions.options.wireframes',
    slug: CategorySlug.WIREFRAMES,
  },
  {
    translationKey: 'app.topBar.search.suggestions.options.minimal',
    slug: CategorySlug.MINIMAL,
  },
];

interface SearchSuggestionsProps {
  onSuggestionClick?: (value: Suggestion) => void;
}

export const SearchSuggestions: FC<SearchSuggestionsProps> = ({
  onSuggestionClick,
}) => {
  const { t } = useTranslation();
  const { criteria } = useSearch();
  const selectedCategory = useSelectedCategory();
  const { is } = useExperiments();

  const isNewMegaMenu = is(
    'specs.funnel.StudioTemplatesMegaMenuNewUiV3',
    'true',
  );

  return (
    <div className={s.suggestions}>
      <div className={classNames(s.label, { [s.newMegaMenu]: isNewMegaMenu })}>
        {t('app.topBar.v2.search.suggestions.label')}
      </div>
      <div className={s.divider} />
      {SEARCH_SUGGESTIONS_LIST.map(({ slug, translationKey }) => (
        <SearchSuggestionButton
          onClick={() => onSuggestionClick?.({ slug, translationKey })}
          isActive={
            selectedCategory && isCategorySlug(slug)
              ? selectedCategory.slug === slug
              : criteria === t(translationKey)
          }
          key={slug}
        >
          {t(translationKey)}
        </SearchSuggestionButton>
      ))}
    </div>
  );
};
